import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { Collapse, List, ListProps, styled } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { NavigationMenuItem, NavigationMenuItemProps } from './NavigationMenuItem';
import { isNavigationMenuCollapsedState } from '@modules/application/atoms';

interface OwnProps {
  icon: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  expanded?: boolean;
}

export type NavigationMenuSubMenuProps =
  & OwnProps;

const StyledSubMenuItem = styled(NavigationMenuItem)<NavigationMenuItemProps>(() => ({
  flex: '0 0 auto',
  '&.expanded': {
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 5px 0px rgba(0,0,0,0.14)',
    zIndex: 1
  },
}));

const StyledSubMenuChildren = styled(List)<ListProps>(() => ({
  background: 'rgba(0, 0, 0, 0.2)',
  paddingTop: 0,
  paddingBottom: 0,
}));

export const NavigationMenuSubMenu: React.FC<NavigationMenuSubMenuProps> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.expanded ?? false);
  const [isNavigationMenuCollapsed, setIsNavigationMenuCollapsed] = useAtom(isNavigationMenuCollapsedState);

  const canOpen = !isNavigationMenuCollapsed;
  const isExpanded = (props.expanded ?? false) || isOpen;
  const buttonClassName = isExpanded && canOpen ? 'expanded' : 'collapsed';

  useEffect(() => {
    setIsOpen(props.expanded ?? false);
  }, [props.expanded]);

  const toggleSubMenu = () => {
    setIsOpen(!isOpen);

    if (isNavigationMenuCollapsed) {
      setIsNavigationMenuCollapsed(false);
      setIsOpen(true);
    }
  };

  return (
    <>
      <StyledSubMenuItem className={buttonClassName} icon={props.icon} title={props.title} onClick={toggleSubMenu}>
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </StyledSubMenuItem>

      <Collapse in={isExpanded && canOpen} timeout="auto">
        <StyledSubMenuChildren disablePadding>
          {props.children}
        </StyledSubMenuChildren>
      </Collapse>
    </>
  );
};